const STORAGE_KEY = 'inventwee_pending_recognition_photo';

/** Persiste la photo entre un aller-retour caméra mobile (rechargement SPA). */
export function stashPendingRecognitionPhoto(dataUrl: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, dataUrl);
  } catch {
    // quota dépassée — ignorer
  }
}

export function takePendingRecognitionPhoto(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    if (value) sessionStorage.removeItem(STORAGE_KEY);
    return value;
  } catch {
    return null;
  }
}

export function clearPendingRecognitionPhoto(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
